export const EmptyDraftSvg = () => {
  return (
    <svg
      width="190"
      height="188"
      viewBox="0 0 190 188"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_12042_41755)">
        <path
          d="M153.027 73.2785C153.027 113.75 89.6427 156.062 49.172 156.062C8.70122 156.062 6.46289 113.75 6.46289 73.2785C6.46289 32.8067 39.2712 0 79.745 0C120.219 0 153.027 32.8067 153.027 73.2785Z"
          fill="#EDDE9F"
        />
      </g>
      <mask
        id="mask0_12042_41755"
        maskUnits="userSpaceOnUse"
        x="28"
        y="21"
        width="155"
        height="155"
      >
        <path
          d="M182.604 98.4706C182.604 140.928 148.107 175.347 105.552 175.347C62.9975 175.347 28.5 140.928 28.5 98.4706C28.5 56.0129 62.9975 21.5941 105.552 21.5941C148.107 21.5941 182.604 56.0129 182.604 98.4706Z"
          fill="#D25252"
        />
      </mask>
      <g mask="url(#mask0_12042_41755)">
        <path
          d="M29.4795 22.2793C29.4795 22.5196 29.2843 22.7144 29.0435 22.7144C28.8026 22.7144 28.6074 22.5196 28.6074 22.2793C28.6074 22.039 28.8026 21.8442 29.0435 21.8442C29.2843 21.8442 29.4795 22.039 29.4795 22.2793Z"
          fill="black"
        />
        <path
          d="M65.417 22.2793C65.417 22.5196 65.2218 22.7144 64.981 22.7144C64.7401 22.7144 64.5449 22.5196 64.5449 22.2793C64.5449 22.039 64.7401 21.8442 64.981 21.8442C65.2218 21.8442 65.417 22.039 65.417 22.2793Z"
          fill="black"
        />
        <path
          d="M137.292 22.2793C137.292 22.5196 137.097 22.7144 136.856 22.7144C136.615 22.7144 136.42 22.5196 136.42 22.2793C136.42 22.039 136.615 21.8442 136.856 21.8442C137.097 21.8442 137.292 22.039 137.292 22.2793Z"
          fill="black"
        />
        <path
          d="M41.458 22.2793C41.458 22.5196 41.2628 22.7144 41.022 22.7144C40.7812 22.7144 40.5859 22.5196 40.5859 22.2793C40.5859 22.039 40.7812 21.8442 41.022 21.8442C41.2628 21.8442 41.458 22.039 41.458 22.2793Z"
          fill="black"
        />
        <path
          d="M77.3955 22.2793C77.3955 22.5196 77.2003 22.7144 76.9595 22.7144C76.7187 22.7144 76.5234 22.5196 76.5234 22.2793C76.5234 22.039 76.7187 21.8442 76.9595 21.8442C77.2003 21.8442 77.3955 22.039 77.3955 22.2793Z"
          fill="black"
        />
        <path
          d="M149.271 22.2793C149.271 22.5196 149.075 22.7144 148.834 22.7144C148.594 22.7144 148.398 22.5196 148.398 22.2793C148.398 22.039 148.594 21.8442 148.834 21.8442C149.075 21.8442 149.271 22.039 149.271 22.2793Z"
          fill="black"
        />
        <path
          d="M101.355 22.2793C101.355 22.5196 101.159 22.7144 100.918 22.7144C100.678 22.7144 100.482 22.5196 100.482 22.2793C100.482 22.039 100.678 21.8442 100.918 21.8442C101.159 21.8442 101.355 22.039 101.355 22.2793Z"
          fill="black"
        />
        <path
          d="M173.228 22.2793C173.228 22.5196 173.032 22.7144 172.792 22.7144C172.551 22.7144 172.355 22.5196 172.355 22.2793C172.355 22.039 172.551 21.8442 172.792 21.8442C173.032 21.8442 173.228 22.039 173.228 22.2793Z"
          fill="black"
        />
        <path
          d="M53.4385 22.2793C53.4385 22.5196 53.2433 22.7144 53.0025 22.7144C52.7616 22.7144 52.5664 22.5196 52.5664 22.2793C52.5664 22.039 52.7616 21.8442 53.0025 21.8442C53.2433 21.8442 53.4385 22.039 53.4385 22.2793Z"
          fill="black"
        />
        <path
          d="M125.312 22.2793C125.312 22.5196 125.116 22.7144 124.876 22.7144C124.635 22.7144 124.439 22.5196 124.439 22.2793C124.439 22.039 124.635 21.8442 124.876 21.8442C125.116 21.8442 125.312 22.039 125.312 22.2793Z"
          fill="black"
        />
        <path
          d="M89.3741 22.2793C89.3741 22.5196 89.1788 22.7144 88.938 22.7144C88.6972 22.7144 88.502 22.5196 88.502 22.2793C88.502 22.039 88.6972 21.8442 88.938 21.8442C89.1788 21.8442 89.3741 22.039 89.3741 22.2793Z"
          fill="black"
        />
        <path
          d="M161.249 22.2793C161.249 22.5196 161.054 22.7144 160.813 22.7144C160.572 22.7144 160.377 22.5196 160.377 22.2793C160.377 22.039 160.572 21.8442 160.813 21.8442C161.054 21.8442 161.249 22.039 161.249 22.2793Z"
          fill="black"
        />
        <path
          d="M113.333 22.2793C113.333 22.5196 113.138 22.7144 112.897 22.7144C112.656 22.7144 112.461 22.5196 112.461 22.2793C112.461 22.039 112.656 21.8442 112.897 21.8442C113.138 21.8442 113.333 22.039 113.333 22.2793Z"
          fill="black"
        />
        <path
          d="M29.4795 34.231C29.4795 34.4712 29.2843 34.666 29.0435 34.666C28.8026 34.666 28.6074 34.4712 28.6074 34.231C28.6074 33.9907 28.8026 33.7959 29.0435 33.7959C29.2843 33.7959 29.4795 33.9907 29.4795 34.231Z"
          fill="black"
        />
        <path
          d="M65.417 34.231C65.417 34.4712 65.2218 34.666 64.981 34.666C64.7401 34.666 64.5449 34.4712 64.5449 34.231C64.5449 33.9907 64.7401 33.7959 64.981 33.7959C65.2218 33.7959 65.417 33.9907 65.417 34.231Z"
          fill="black"
        />
        <path
          d="M137.292 34.231C137.292 34.4712 137.097 34.666 136.856 34.666C136.615 34.666 136.42 34.4712 136.42 34.231C136.42 33.9907 136.615 33.7959 136.856 33.7959C137.097 33.7959 137.292 33.9907 137.292 34.231Z"
          fill="black"
        />
        <path
          d="M41.458 34.231C41.458 34.4712 41.2628 34.666 41.022 34.666C40.7812 34.666 40.5859 34.4712 40.5859 34.231C40.5859 33.9907 40.7812 33.7959 41.022 33.7959C41.2628 33.7959 41.458 33.9907 41.458 34.231Z"
          fill="black"
        />
        <path
          d="M77.3955 34.231C77.3955 34.4712 77.2003 34.666 76.9595 34.666C76.7187 34.666 76.5234 34.4712 76.5234 34.231C76.5234 33.9907 76.7187 33.7959 76.9595 33.7959C77.2003 33.7959 77.3955 33.9907 77.3955 34.231Z"
          fill="black"
        />
        <path
          d="M149.271 34.231C149.271 34.4712 149.075 34.666 148.834 34.666C148.594 34.666 148.398 34.4712 148.398 34.231C148.398 33.9907 148.594 33.7959 148.834 33.7959C149.075 33.7959 149.271 33.9907 149.271 34.231Z"
          fill="black"
        />
        <path
          d="M101.355 34.231C101.355 34.4712 101.159 34.666 100.918 34.666C100.678 34.666 100.482 34.4712 100.482 34.231C100.482 33.9907 100.678 33.7959 100.918 33.7959C101.159 33.7959 101.355 33.9907 101.355 34.231Z"
          fill="black"
        />
        <path
          d="M173.228 34.231C173.228 34.4712 173.032 34.666 172.792 34.666C172.551 34.666 172.355 34.4712 172.355 34.231C172.355 33.9907 172.551 33.7959 172.792 33.7959C173.032 33.7959 173.228 33.9907 173.228 34.231Z"
          fill="black"
        />
        <path
          d="M53.4385 34.231C53.4385 34.4712 53.2433 34.666 53.0025 34.666C52.7616 34.666 52.5664 34.4712 52.5664 34.231C52.5664 33.9907 52.7616 33.7959 53.0025 33.7959C53.2433 33.7959 53.4385 33.9907 53.4385 34.231Z"
          fill="black"
        />
        <path
          d="M125.312 34.231C125.312 34.4712 125.116 34.666 124.876 34.666C124.635 34.666 124.439 34.4712 124.439 34.231C124.439 33.9907 124.635 33.7959 124.876 33.7959C125.116 33.7959 125.312 33.9907 125.312 34.231Z"
          fill="black"
        />
        <path
          d="M89.3741 34.231C89.3741 34.4712 89.1788 34.666 88.938 34.666C88.6972 34.666 88.502 34.4712 88.502 34.231C88.502 33.9907 88.6972 33.7959 88.938 33.7959C89.1788 33.7959 89.3741 33.9907 89.3741 34.231Z"
          fill="black"
        />
        <path
          d="M161.249 34.231C161.249 34.4712 161.054 34.666 160.813 34.666C160.572 34.666 160.377 34.4712 160.377 34.231C160.377 33.9907 160.572 33.7959 160.813 33.7959C161.054 33.7959 161.249 33.9907 161.249 34.231Z"
          fill="black"
        />
        <path
          d="M113.333 34.231C113.333 34.4712 113.138 34.666 112.897 34.666C112.656 34.666 112.461 34.4712 112.461 34.231C112.461 33.9907 112.656 33.7959 112.897 33.7959C113.138 33.7959 113.333 33.9907 113.333 34.231Z"
          fill="black"
        />
        <path
          d="M29.4795 46.1827C29.4795 46.423 29.2843 46.6178 29.0435 46.6178C28.8026 46.6178 28.6074 46.423 28.6074 46.1827C28.6074 45.9425 28.8026 45.7477 29.0435 45.7477C29.2843 45.7477 29.4795 45.9425 29.4795 46.1827Z"
          fill="black"
        />
        <path
          d="M65.417 46.1827C65.417 46.423 65.2218 46.6178 64.981 46.6178C64.7401 46.6178 64.5449 46.423 64.5449 46.1827C64.5449 45.9425 64.7401 45.7477 64.981 45.7477C65.2218 45.7477 65.417 45.9425 65.417 46.1827Z"
          fill="black"
        />
        <path
          d="M137.292 46.1827C137.292 46.423 137.097 46.6178 136.856 46.6178C136.615 46.6178 136.42 46.423 136.42 46.1827C136.42 45.9425 136.615 45.7477 136.856 45.7477C137.097 45.7477 137.292 45.9425 137.292 46.1827Z"
          fill="black"
        />
        <path
          d="M41.458 46.1827C41.458 46.423 41.2628 46.6178 41.022 46.6178C40.7812 46.6178 40.5859 46.423 40.5859 46.1827C40.5859 45.9425 40.7812 45.7477 41.022 45.7477C41.2628 45.7477 41.458 45.9425 41.458 46.1827Z"
          fill="black"
        />
        <path
          d="M77.3955 46.1827C77.3955 46.423 77.2003 46.6178 76.9595 46.6178C76.7187 46.6178 76.5234 46.423 76.5234 46.1827C76.5234 45.9425 76.7187 45.7477 76.9595 45.7477C77.2003 45.7477 77.3955 45.9425 77.3955 46.1827Z"
          fill="black"
        />
        <path
          d="M149.271 46.1827C149.271 46.423 149.075 46.6178 148.834 46.6178C148.594 46.6178 148.398 46.423 148.398 46.1827C148.398 45.9425 148.594 45.7477 148.834 45.7477C149.075 45.7477 149.271 45.9425 149.271 46.1827Z"
          fill="black"
        />
        <path
          d="M101.355 46.1827C101.355 46.423 101.159 46.6178 100.918 46.6178C100.678 46.6178 100.482 46.423 100.482 46.1827C100.482 45.9425 100.678 45.7477 100.918 45.7477C101.159 45.7477 101.355 45.9425 101.355 46.1827Z"
          fill="black"
        />
        <path
          d="M173.228 46.1827C173.228 46.423 173.032 46.6178 172.792 46.6178C172.551 46.6178 172.355 46.423 172.355 46.1827C172.355 45.9425 172.551 45.7477 172.792 45.7477C173.032 45.7477 173.228 45.9425 173.228 46.1827Z"
          fill="black"
        />
        <path
          d="M53.4385 46.1827C53.4385 46.423 53.2433 46.6178 53.0025 46.6178C52.7616 46.6178 52.5664 46.423 52.5664 46.1827C52.5664 45.9425 52.7616 45.7477 53.0025 45.7477C53.2433 45.7477 53.4385 45.9425 53.4385 46.1827Z"
          fill="black"
        />
        <path
          d="M125.312 46.1827C125.312 46.423 125.116 46.6178 124.876 46.6178C124.635 46.6178 124.439 46.423 124.439 46.1827C124.439 45.9425 124.635 45.7477 124.876 45.7477C125.116 45.7477 125.312 45.9425 125.312 46.1827Z"
          fill="black"
        />
        <path
          d="M89.3741 46.1827C89.3741 46.423 89.1788 46.6178 88.938 46.6178C88.6972 46.6178 88.502 46.423 88.502 46.1827C88.502 45.9425 88.6972 45.7477 88.938 45.7477C89.1788 45.7477 89.3741 45.9425 89.3741 46.1827Z"
          fill="black"
        />
        <path
          d="M161.249 46.1827C161.249 46.423 161.054 46.6178 160.813 46.6178C160.572 46.6178 160.377 46.423 160.377 46.1827C160.377 45.9425 160.572 45.7477 160.813 45.7477C161.054 45.7477 161.249 45.9425 161.249 46.1827Z"
          fill="black"
        />
        <path
          d="M113.333 46.1827C113.333 46.423 113.138 46.6178 112.897 46.6178C112.656 46.6178 112.461 46.423 112.461 46.1827C112.461 45.9425 112.656 45.7477 112.897 45.7477C113.138 45.7477 113.333 45.9425 113.333 46.1827Z"
          fill="black"
        />
        <path
          d="M29.4795 93.9896C29.4795 94.2299 29.2843 94.4247 29.0435 94.4247C28.8026 94.4247 28.6074 94.2299 28.6074 93.9896C28.6074 93.7493 28.8026 93.5546 29.0435 93.5546C29.2843 93.5546 29.4795 93.7493 29.4795 93.9896Z"
          fill="black"
        />
        <path
          d="M65.417 93.9896C65.417 94.2299 65.2218 94.4247 64.981 94.4247C64.7401 94.4247 64.5449 94.2299 64.5449 93.9896C64.5449 93.7493 64.7401 93.5546 64.981 93.5546C65.2218 93.5546 65.417 93.7493 65.417 93.9896Z"
          fill="black"
        />
        <path
          d="M137.292 93.9896C137.292 94.2299 137.097 94.4247 136.856 94.4247C136.615 94.4247 136.42 94.2299 136.42 93.9896C136.42 93.7493 136.615 93.5546 136.856 93.5546C137.097 93.5546 137.292 93.7493 137.292 93.9896Z"
          fill="black"
        />
        <path
          d="M41.458 93.9896C41.458 94.2299 41.2628 94.4247 41.022 94.4247C40.7812 94.4247 40.5859 94.2299 40.5859 93.9896C40.5859 93.7493 40.7812 93.5546 41.022 93.5546C41.2628 93.5546 41.458 93.7493 41.458 93.9896Z"
          fill="black"
        />
        <path
          d="M77.3955 93.9896C77.3955 94.2299 77.2003 94.4247 76.9595 94.4247C76.7187 94.4247 76.5234 94.2299 76.5234 93.9896C76.5234 93.7493 76.7187 93.5546 76.9595 93.5546C77.2003 93.5546 77.3955 93.7493 77.3955 93.9896Z"
          fill="black"
        />
        <path
          d="M149.271 93.9896C149.271 94.2299 149.075 94.4247 148.834 94.4247C148.594 94.4247 148.398 94.2299 148.398 93.9896C148.398 93.7493 148.594 93.5546 148.834 93.5546C149.075 93.5546 149.271 93.7493 149.271 93.9896Z"
          fill="black"
        />
        <path
          d="M101.355 93.9896C101.355 94.2299 101.159 94.4247 100.918 94.4247C100.678 94.4247 100.482 94.2299 100.482 93.9896C100.482 93.7493 100.678 93.5546 100.918 93.5546C101.159 93.5546 101.355 93.7493 101.355 93.9896Z"
          fill="black"
        />
        <path
          d="M173.228 93.9896C173.228 94.2299 173.032 94.4247 172.792 94.4247C172.551 94.4247 172.355 94.2299 172.355 93.9896C172.355 93.7493 172.551 93.5546 172.792 93.5546C173.032 93.5546 173.228 93.7493 173.228 93.9896Z"
          fill="black"
        />
        <path
          d="M53.4385 93.9896C53.4385 94.2299 53.2433 94.4247 53.0025 94.4247C52.7616 94.4247 52.5664 94.2299 52.5664 93.9896C52.5664 93.7493 52.7616 93.5546 53.0025 93.5546C53.2433 93.5546 53.4385 93.7493 53.4385 93.9896Z"
          fill="black"
        />
        <path
          d="M125.312 93.9896C125.312 94.2299 125.116 94.4247 124.876 94.4247C124.635 94.4247 124.439 94.2299 124.439 93.9896C124.439 93.7493 124.635 93.5546 124.876 93.5546C125.116 93.5546 125.312 93.7493 125.312 93.9896Z"
          fill="black"
        />
        <path
          d="M89.3741 93.9896C89.3741 94.2299 89.1788 94.4247 88.938 94.4247C88.6972 94.4247 88.502 94.2299 88.502 93.9896C88.502 93.7493 88.6972 93.5546 88.938 93.5546C89.1788 93.5546 89.3741 93.7493 89.3741 93.9896Z"
          fill="black"
        />
        <path
          d="M161.249 93.9896C161.249 94.2299 161.054 94.4247 160.813 94.4247C160.572 94.4247 160.377 94.2299 160.377 93.9896C160.377 93.7493 160.572 93.5546 160.813 93.5546C161.054 93.5546 161.249 93.7493 161.249 93.9896Z"
          fill="black"
        />
        <path
          d="M113.333 93.9896C113.333 94.2299 113.138 94.4247 112.897 94.4247C112.656 94.4247 112.461 94.2299 112.461 93.9896C112.461 93.7493 112.656 93.5546 112.897 93.5546C113.138 93.5546 113.333 93.7493 113.333 93.9896Z"
          fill="black"
        />
        <path
          d="M29.4795 141.797C29.4795 142.037 29.2843 142.232 29.0435 142.232C28.8026 142.232 28.6074 142.037 28.6074 141.797C28.6074 141.556 28.8026 141.361 29.0435 141.361C29.2843 141.361 29.4795 141.556 29.4795 141.797Z"
          fill="black"
        />
        <path
          d="M65.417 141.797C65.417 142.037 65.2218 142.232 64.981 142.232C64.7401 142.232 64.5449 142.037 64.5449 141.797C64.5449 141.556 64.7401 141.361 64.981 141.361C65.2218 141.361 65.417 141.556 65.417 141.797Z"
          fill="black"
        />
        <path
          d="M137.292 141.797C137.292 142.037 137.097 142.232 136.856 142.232C136.615 142.232 136.42 142.037 136.42 141.797C136.42 141.556 136.615 141.361 136.856 141.361C137.097 141.361 137.292 141.556 137.292 141.797Z"
          fill="black"
        />
        <path
          d="M41.458 141.797C41.458 142.037 41.2628 142.232 41.022 142.232C40.7812 142.232 40.5859 142.037 40.5859 141.797C40.5859 141.556 40.7812 141.361 41.022 141.361C41.2628 141.361 41.458 141.556 41.458 141.797Z"
          fill="black"
        />
        <path
          d="M77.3955 141.797C77.3955 142.037 77.2003 142.232 76.9595 142.232C76.7187 142.232 76.5234 142.037 76.5234 141.797C76.5234 141.556 76.7187 141.361 76.9595 141.361C77.2003 141.361 77.3955 141.556 77.3955 141.797Z"
          fill="black"
        />
        <path
          d="M149.271 141.797C149.271 142.037 149.075 142.232 148.834 142.232C148.594 142.232 148.398 142.037 148.398 141.797C148.398 141.556 148.594 141.361 148.834 141.361C149.075 141.361 149.271 141.556 149.271 141.797Z"
          fill="black"
        />
        <path
          d="M101.355 141.797C101.355 142.037 101.159 142.232 100.918 142.232C100.678 142.232 100.482 142.037 100.482 141.797C100.482 141.556 100.678 141.361 100.918 141.361C101.159 141.361 101.355 141.556 101.355 141.797Z"
          fill="black"
        />
        <path
          d="M173.228 141.797C173.228 142.037 173.032 142.232 172.792 142.232C172.551 142.232 172.355 142.037 172.355 141.797C172.355 141.556 172.551 141.361 172.792 141.361C173.032 141.361 173.228 141.556 173.228 141.797Z"
          fill="black"
        />
        <path
          d="M53.4385 141.797C53.4385 142.037 53.2433 142.232 53.0025 142.232C52.7616 142.232 52.5664 142.037 52.5664 141.797C52.5664 141.556 52.7616 141.361 53.0025 141.361C53.2433 141.361 53.4385 141.556 53.4385 141.797Z"
          fill="black"
        />
        <path
          d="M125.312 141.797C125.312 142.037 125.116 142.232 124.876 142.232C124.635 142.232 124.439 142.037 124.439 141.797C124.439 141.556 124.635 141.361 124.876 141.361C125.116 141.361 125.312 141.556 125.312 141.797Z"
          fill="black"
        />
        <path
          d="M89.3741 141.797C89.3741 142.037 89.1788 142.232 88.938 142.232C88.6972 142.232 88.502 142.037 88.502 141.797C88.502 141.556 88.6972 141.361 88.938 141.361C89.1788 141.361 89.3741 141.556 89.3741 141.797Z"
          fill="black"
        />
        <path
          d="M161.249 141.797C161.249 142.037 161.054 142.232 160.813 142.232C160.572 142.232 160.377 142.037 160.377 141.797C160.377 141.556 160.572 141.361 160.813 141.361C161.054 141.361 161.249 141.556 161.249 141.797Z"
          fill="black"
        />
        <path
          d="M113.333 141.797C113.333 142.037 113.138 142.232 112.897 142.232C112.656 142.232 112.461 142.037 112.461 141.797C112.461 141.556 112.656 141.361 112.897 141.361C113.138 141.361 113.333 141.556 113.333 141.797Z"
          fill="black"
        />
        <path
          d="M29.4795 58.1344C29.4795 58.3747 29.2843 58.5695 29.0435 58.5695C28.8026 58.5695 28.6074 58.3747 28.6074 58.1344C28.6074 57.8941 28.8026 57.6993 29.0435 57.6993C29.2843 57.6993 29.4795 57.8941 29.4795 58.1344Z"
          fill="black"
        />
        <path
          d="M65.417 58.1344C65.417 58.3747 65.2218 58.5695 64.981 58.5695C64.7401 58.5695 64.5449 58.3747 64.5449 58.1344C64.5449 57.8941 64.7401 57.6993 64.981 57.6993C65.2218 57.6993 65.417 57.8941 65.417 58.1344Z"
          fill="black"
        />
        <path
          d="M137.292 58.1344C137.292 58.3747 137.097 58.5695 136.856 58.5695C136.615 58.5695 136.42 58.3747 136.42 58.1344C136.42 57.8941 136.615 57.6993 136.856 57.6993C137.097 57.6993 137.292 57.8941 137.292 58.1344Z"
          fill="black"
        />
        <path
          d="M41.458 58.1344C41.458 58.3747 41.2628 58.5695 41.022 58.5695C40.7812 58.5695 40.5859 58.3747 40.5859 58.1344C40.5859 57.8941 40.7812 57.6993 41.022 57.6993C41.2628 57.6993 41.458 57.8941 41.458 58.1344Z"
          fill="black"
        />
        <path
          d="M77.3955 58.1344C77.3955 58.3747 77.2003 58.5695 76.9595 58.5695C76.7187 58.5695 76.5234 58.3747 76.5234 58.1344C76.5234 57.8941 76.7187 57.6993 76.9595 57.6993C77.2003 57.6993 77.3955 57.8941 77.3955 58.1344Z"
          fill="black"
        />
        <path
          d="M149.271 58.1344C149.271 58.3747 149.075 58.5695 148.834 58.5695C148.594 58.5695 148.398 58.3747 148.398 58.1344C148.398 57.8941 148.594 57.6993 148.834 57.6993C149.075 57.6993 149.271 57.8941 149.271 58.1344Z"
          fill="black"
        />
        <path
          d="M101.355 58.1344C101.355 58.3747 101.159 58.5695 100.918 58.5695C100.678 58.5695 100.482 58.3747 100.482 58.1344C100.482 57.8941 100.678 57.6993 100.918 57.6993C101.159 57.6993 101.355 57.8941 101.355 58.1344Z"
          fill="black"
        />
        <path
          d="M173.228 58.1344C173.228 58.3747 173.032 58.5695 172.792 58.5695C172.551 58.5695 172.355 58.3747 172.355 58.1344C172.355 57.8941 172.551 57.6993 172.792 57.6993C173.032 57.6993 173.228 57.8941 173.228 58.1344Z"
          fill="black"
        />
        <path
          d="M53.4385 58.1344C53.4385 58.3747 53.2433 58.5695 53.0025 58.5695C52.7616 58.5695 52.5664 58.3747 52.5664 58.1344C52.5664 57.8941 52.7616 57.6993 53.0025 57.6993C53.2433 57.6993 53.4385 57.8941 53.4385 58.1344Z"
          fill="black"
        />
        <path
          d="M125.312 58.1344C125.312 58.3747 125.116 58.5695 124.876 58.5695C124.635 58.5695 124.439 58.3747 124.439 58.1344C124.439 57.8941 124.635 57.6993 124.876 57.6993C125.116 57.6993 125.312 57.8941 125.312 58.1344Z"
          fill="black"
        />
        <path
          d="M89.3741 58.1344C89.3741 58.3747 89.1788 58.5695 88.938 58.5695C88.6972 58.5695 88.502 58.3747 88.502 58.1344C88.502 57.8941 88.6972 57.6993 88.938 57.6993C89.1788 57.6993 89.3741 57.8941 89.3741 58.1344Z"
          fill="black"
        />
        <path
          d="M161.249 58.1344C161.249 58.3747 161.054 58.5695 160.813 58.5695C160.572 58.5695 160.377 58.3747 160.377 58.1344C160.377 57.8941 160.572 57.6993 160.813 57.6993C161.054 57.6993 161.249 57.8941 161.249 58.1344Z"
          fill="black"
        />
        <path
          d="M113.333 58.1344C113.333 58.3747 113.138 58.5695 112.897 58.5695C112.656 58.5695 112.461 58.3747 112.461 58.1344C112.461 57.8941 112.656 57.6993 112.897 57.6993C113.138 57.6993 113.333 57.8941 113.333 58.1344Z"
          fill="black"
        />
        <path
          d="M29.4795 105.941C29.4795 106.182 29.2843 106.376 29.0435 106.376C28.8026 106.376 28.6074 106.182 28.6074 105.941C28.6074 105.701 28.8026 105.506 29.0435 105.506C29.2843 105.506 29.4795 105.701 29.4795 105.941Z"
          fill="black"
        />
        <path
          d="M65.417 105.941C65.417 106.182 65.2218 106.376 64.981 106.376C64.7401 106.376 64.5449 106.182 64.5449 105.941C64.5449 105.701 64.7401 105.506 64.981 105.506C65.2218 105.506 65.417 105.701 65.417 105.941Z"
          fill="black"
        />
        <path
          d="M137.292 105.941C137.292 106.182 137.097 106.376 136.856 106.376C136.615 106.376 136.42 106.182 136.42 105.941C136.42 105.701 136.615 105.506 136.856 105.506C137.097 105.506 137.292 105.701 137.292 105.941Z"
          fill="black"
        />
        <path
          d="M41.458 105.941C41.458 106.182 41.2628 106.376 41.022 106.376C40.7812 106.376 40.5859 106.182 40.5859 105.941C40.5859 105.701 40.7812 105.506 41.022 105.506C41.2628 105.506 41.458 105.701 41.458 105.941Z"
          fill="black"
        />
        <path
          d="M77.3955 105.941C77.3955 106.182 77.2003 106.376 76.9595 106.376C76.7187 106.376 76.5234 106.182 76.5234 105.941C76.5234 105.701 76.7187 105.506 76.9595 105.506C77.2003 105.506 77.3955 105.701 77.3955 105.941Z"
          fill="black"
        />
        <path
          d="M149.271 105.941C149.271 106.182 149.075 106.376 148.834 106.376C148.594 106.376 148.398 106.182 148.398 105.941C148.398 105.701 148.594 105.506 148.834 105.506C149.075 105.506 149.271 105.701 149.271 105.941Z"
          fill="black"
        />
        <path
          d="M101.355 105.941C101.355 106.182 101.159 106.376 100.918 106.376C100.678 106.376 100.482 106.182 100.482 105.941C100.482 105.701 100.678 105.506 100.918 105.506C101.159 105.506 101.355 105.701 101.355 105.941Z"
          fill="black"
        />
        <path
          d="M173.228 105.941C173.228 106.182 173.032 106.376 172.792 106.376C172.551 106.376 172.355 106.182 172.355 105.941C172.355 105.701 172.551 105.506 172.792 105.506C173.032 105.506 173.228 105.701 173.228 105.941Z"
          fill="black"
        />
        <path
          d="M53.4385 105.941C53.4385 106.182 53.2433 106.376 53.0025 106.376C52.7616 106.376 52.5664 106.182 52.5664 105.941C52.5664 105.701 52.7616 105.506 53.0025 105.506C53.2433 105.506 53.4385 105.701 53.4385 105.941Z"
          fill="black"
        />
        <path
          d="M125.312 105.941C125.312 106.182 125.116 106.376 124.876 106.376C124.635 106.376 124.439 106.182 124.439 105.941C124.439 105.701 124.635 105.506 124.876 105.506C125.116 105.506 125.312 105.701 125.312 105.941Z"
          fill="black"
        />
        <path
          d="M89.3741 105.941C89.3741 106.182 89.1788 106.376 88.938 106.376C88.6972 106.376 88.502 106.182 88.502 105.941C88.502 105.701 88.6972 105.506 88.938 105.506C89.1788 105.506 89.3741 105.701 89.3741 105.941Z"
          fill="black"
        />
        <path
          d="M161.249 105.941C161.249 106.182 161.054 106.376 160.813 106.376C160.572 106.376 160.377 106.182 160.377 105.941C160.377 105.701 160.572 105.506 160.813 105.506C161.054 105.506 161.249 105.701 161.249 105.941Z"
          fill="black"
        />
        <path
          d="M113.333 105.941C113.333 106.182 113.138 106.376 112.897 106.376C112.656 106.376 112.461 106.182 112.461 105.941C112.461 105.701 112.656 105.506 112.897 105.506C113.138 105.506 113.333 105.701 113.333 105.941Z"
          fill="black"
        />
        <path
          d="M29.4795 153.748C29.4795 153.989 29.2843 154.183 29.0435 154.183C28.8026 154.183 28.6074 153.989 28.6074 153.748C28.6074 153.508 28.8026 153.313 29.0435 153.313C29.2843 153.313 29.4795 153.508 29.4795 153.748Z"
          fill="black"
        />
        <path
          d="M65.417 153.748C65.417 153.989 65.2218 154.183 64.981 154.183C64.7401 154.183 64.5449 153.989 64.5449 153.748C64.5449 153.508 64.7401 153.313 64.981 153.313C65.2218 153.313 65.417 153.508 65.417 153.748Z"
          fill="black"
        />
        <path
          d="M137.292 153.748C137.292 153.989 137.097 154.183 136.856 154.183C136.615 154.183 136.42 153.989 136.42 153.748C136.42 153.508 136.615 153.313 136.856 153.313C137.097 153.313 137.292 153.508 137.292 153.748Z"
          fill="black"
        />
        <path
          d="M41.458 153.748C41.458 153.989 41.2628 154.183 41.022 154.183C40.7812 154.183 40.5859 153.989 40.5859 153.748C40.5859 153.508 40.7812 153.313 41.022 153.313C41.2628 153.313 41.458 153.508 41.458 153.748Z"
          fill="black"
        />
        <path
          d="M77.3955 153.748C77.3955 153.989 77.2003 154.183 76.9595 154.183C76.7187 154.183 76.5234 153.989 76.5234 153.748C76.5234 153.508 76.7187 153.313 76.9595 153.313C77.2003 153.313 77.3955 153.508 77.3955 153.748Z"
          fill="black"
        />
        <path
          d="M149.271 153.748C149.271 153.989 149.075 154.183 148.834 154.183C148.594 154.183 148.398 153.989 148.398 153.748C148.398 153.508 148.594 153.313 148.834 153.313C149.075 153.313 149.271 153.508 149.271 153.748Z"
          fill="black"
        />
        <path
          d="M101.355 153.748C101.355 153.989 101.159 154.183 100.918 154.183C100.678 154.183 100.482 153.989 100.482 153.748C100.482 153.508 100.678 153.313 100.918 153.313C101.159 153.313 101.355 153.508 101.355 153.748Z"
          fill="black"
        />
        <path
          d="M173.228 153.748C173.228 153.989 173.032 154.183 172.792 154.183C172.551 154.183 172.355 153.989 172.355 153.748C172.355 153.508 172.551 153.313 172.792 153.313C173.032 153.313 173.228 153.508 173.228 153.748Z"
          fill="black"
        />
        <path
          d="M53.4385 153.748C53.4385 153.989 53.2433 154.183 53.0025 154.183C52.7616 154.183 52.5664 153.989 52.5664 153.748C52.5664 153.508 52.7616 153.313 53.0025 153.313C53.2433 153.313 53.4385 153.508 53.4385 153.748Z"
          fill="black"
        />
        <path
          d="M125.312 153.748C125.312 153.989 125.116 154.183 124.876 154.183C124.635 154.183 124.439 153.989 124.439 153.748C124.439 153.508 124.635 153.313 124.876 153.313C125.116 153.313 125.312 153.508 125.312 153.748Z"
          fill="black"
        />
        <path
          d="M89.3741 153.748C89.3741 153.989 89.1788 154.183 88.938 154.183C88.6972 154.183 88.502 153.989 88.502 153.748C88.502 153.508 88.6972 153.313 88.938 153.313C89.1788 153.313 89.3741 153.508 89.3741 153.748Z"
          fill="black"
        />
        <path
          d="M161.249 153.748C161.249 153.989 161.054 154.183 160.813 154.183C160.572 154.183 160.377 153.989 160.377 153.748C160.377 153.508 160.572 153.313 160.813 153.313C161.054 153.313 161.249 153.508 161.249 153.748Z"
          fill="black"
        />
        <path
          d="M113.333 153.748C113.333 153.989 113.138 154.183 112.897 154.183C112.656 154.183 112.461 153.989 112.461 153.748C112.461 153.508 112.656 153.313 112.897 153.313C113.138 153.313 113.333 153.508 113.333 153.748Z"
          fill="black"
        />
        <path
          d="M29.4795 70.0862C29.4795 70.3265 29.2843 70.5212 29.0435 70.5212C28.8026 70.5212 28.6074 70.3265 28.6074 70.0862C28.6074 69.8459 28.8026 69.6511 29.0435 69.6511C29.2843 69.6511 29.4795 69.8459 29.4795 70.0862Z"
          fill="black"
        />
        <path
          d="M65.417 70.0862C65.417 70.3265 65.2218 70.5212 64.981 70.5212C64.7401 70.5212 64.5449 70.3265 64.5449 70.0862C64.5449 69.8459 64.7401 69.6511 64.981 69.6511C65.2218 69.6511 65.417 69.8459 65.417 70.0862Z"
          fill="black"
        />
        <path
          d="M137.292 70.0862C137.292 70.3265 137.097 70.5212 136.856 70.5212C136.615 70.5212 136.42 70.3265 136.42 70.0862C136.42 69.8459 136.615 69.6511 136.856 69.6511C137.097 69.6511 137.292 69.8459 137.292 70.0862Z"
          fill="black"
        />
        <path
          d="M41.458 70.0862C41.458 70.3265 41.2628 70.5212 41.022 70.5212C40.7812 70.5212 40.5859 70.3265 40.5859 70.0862C40.5859 69.8459 40.7812 69.6511 41.022 69.6511C41.2628 69.6511 41.458 69.8459 41.458 70.0862Z"
          fill="black"
        />
        <path
          d="M77.3955 70.0862C77.3955 70.3265 77.2003 70.5212 76.9595 70.5212C76.7187 70.5212 76.5234 70.3265 76.5234 70.0862C76.5234 69.8459 76.7187 69.6511 76.9595 69.6511C77.2003 69.6511 77.3955 69.8459 77.3955 70.0862Z"
          fill="black"
        />
        <path
          d="M149.271 70.0862C149.271 70.3265 149.075 70.5212 148.834 70.5212C148.594 70.5212 148.398 70.3265 148.398 70.0862C148.398 69.8459 148.594 69.6511 148.834 69.6511C149.075 69.6511 149.271 69.8459 149.271 70.0862Z"
          fill="black"
        />
        <path
          d="M101.355 70.0862C101.355 70.3265 101.159 70.5212 100.918 70.5212C100.678 70.5212 100.482 70.3265 100.482 70.0862C100.482 69.8459 100.678 69.6511 100.918 69.6511C101.159 69.6511 101.355 69.8459 101.355 70.0862Z"
          fill="black"
        />
        <path
          d="M173.228 70.0862C173.228 70.3265 173.032 70.5212 172.792 70.5212C172.551 70.5212 172.355 70.3265 172.355 70.0862C172.355 69.8459 172.551 69.6511 172.792 69.6511C173.032 69.6511 173.228 69.8459 173.228 70.0862Z"
          fill="black"
        />
        <path
          d="M53.4385 70.0862C53.4385 70.3265 53.2433 70.5212 53.0025 70.5212C52.7616 70.5212 52.5664 70.3265 52.5664 70.0862C52.5664 69.8459 52.7616 69.6511 53.0025 69.6511C53.2433 69.6511 53.4385 69.8459 53.4385 70.0862Z"
          fill="black"
        />
        <path
          d="M125.312 70.0862C125.312 70.3265 125.116 70.5212 124.876 70.5212C124.635 70.5212 124.439 70.3265 124.439 70.0862C124.439 69.8459 124.635 69.6511 124.876 69.6511C125.116 69.6511 125.312 69.8459 125.312 70.0862Z"
          fill="black"
        />
        <path
          d="M89.3741 70.0862C89.3741 70.3265 89.1788 70.5212 88.938 70.5212C88.6972 70.5212 88.502 70.3265 88.502 70.0862C88.502 69.8459 88.6972 69.6511 88.938 69.6511C89.1788 69.6511 89.3741 69.8459 89.3741 70.0862Z"
          fill="black"
        />
        <path
          d="M161.249 70.0862C161.249 70.3265 161.054 70.5212 160.813 70.5212C160.572 70.5212 160.377 70.3265 160.377 70.0862C160.377 69.8459 160.572 69.6511 160.813 69.6511C161.054 69.6511 161.249 69.8459 161.249 70.0862Z"
          fill="black"
        />
        <path
          d="M113.333 70.0862C113.333 70.3265 113.138 70.5212 112.897 70.5212C112.656 70.5212 112.461 70.3265 112.461 70.0862C112.461 69.8459 112.656 69.6511 112.897 69.6511C113.138 69.6511 113.333 69.8459 113.333 70.0862Z"
          fill="black"
        />
        <path
          d="M29.4795 117.893C29.4795 118.133 29.2843 118.328 29.0435 118.328C28.8026 118.328 28.6074 118.133 28.6074 117.893C28.6074 117.653 28.8026 117.458 29.0435 117.458C29.2843 117.458 29.4795 117.653 29.4795 117.893Z"
          fill="black"
        />
        <path
          d="M65.417 117.893C65.417 118.133 65.2218 118.328 64.981 118.328C64.7401 118.328 64.5449 118.133 64.5449 117.893C64.5449 117.653 64.7401 117.458 64.981 117.458C65.2218 117.458 65.417 117.653 65.417 117.893Z"
          fill="black"
        />
        <path
          d="M137.292 117.893C137.292 118.133 137.097 118.328 136.856 118.328C136.615 118.328 136.42 118.133 136.42 117.893C136.42 117.653 136.615 117.458 136.856 117.458C137.097 117.458 137.292 117.653 137.292 117.893Z"
          fill="black"
        />
        <path
          d="M41.458 117.893C41.458 118.133 41.2628 118.328 41.022 118.328C40.7812 118.328 40.5859 118.133 40.5859 117.893C40.5859 117.653 40.7812 117.458 41.022 117.458C41.2628 117.458 41.458 117.653 41.458 117.893Z"
          fill="black"
        />
        <path
          d="M77.3955 117.893C77.3955 118.133 77.2003 118.328 76.9595 118.328C76.7187 118.328 76.5234 118.133 76.5234 117.893C76.5234 117.653 76.7187 117.458 76.9595 117.458C77.2003 117.458 77.3955 117.653 77.3955 117.893Z"
          fill="black"
        />
        <path
          d="M149.271 117.893C149.271 118.133 149.075 118.328 148.834 118.328C148.594 118.328 148.398 118.133 148.398 117.893C148.398 117.653 148.594 117.458 148.834 117.458C149.075 117.458 149.271 117.653 149.271 117.893Z"
          fill="black"
        />
        <path
          d="M101.355 117.893C101.355 118.133 101.159 118.328 100.918 118.328C100.678 118.328 100.482 118.133 100.482 117.893C100.482 117.653 100.678 117.458 100.918 117.458C101.159 117.458 101.355 117.653 101.355 117.893Z"
          fill="black"
        />
        <path
          d="M173.228 117.893C173.228 118.133 173.032 118.328 172.792 118.328C172.551 118.328 172.355 118.133 172.355 117.893C172.355 117.653 172.551 117.458 172.792 117.458C173.032 117.458 173.228 117.653 173.228 117.893Z"
          fill="black"
        />
        <path
          d="M53.4385 117.893C53.4385 118.133 53.2433 118.328 53.0025 118.328C52.7616 118.328 52.5664 118.133 52.5664 117.893C52.5664 117.653 52.7616 117.458 53.0025 117.458C53.2433 117.458 53.4385 117.653 53.4385 117.893Z"
          fill="black"
        />
        <path
          d="M125.312 117.893C125.312 118.133 125.116 118.328 124.876 118.328C124.635 118.328 124.439 118.133 124.439 117.893C124.439 117.653 124.635 117.458 124.876 117.458C125.116 117.458 125.312 117.653 125.312 117.893Z"
          fill="black"
        />
        <path
          d="M89.3741 117.893C89.3741 118.133 89.1788 118.328 88.938 118.328C88.6972 118.328 88.502 118.133 88.502 117.893C88.502 117.653 88.6972 117.458 88.938 117.458C89.1788 117.458 89.3741 117.653 89.3741 117.893Z"
          fill="black"
        />
        <path
          d="M161.249 117.893C161.249 118.133 161.054 118.328 160.813 118.328C160.572 118.328 160.377 118.133 160.377 117.893C160.377 117.653 160.572 117.458 160.813 117.458C161.054 117.458 161.249 117.653 161.249 117.893Z"
          fill="black"
        />
        <path
          d="M113.333 117.893C113.333 118.133 113.138 118.328 112.897 118.328C112.656 118.328 112.461 118.133 112.461 117.893C112.461 117.653 112.656 117.458 112.897 117.458C113.138 117.458 113.333 117.653 113.333 117.893Z"
          fill="black"
        />
        <path
          d="M29.4795 165.7C29.4795 165.94 29.2843 166.135 29.0435 166.135C28.8026 166.135 28.6074 165.94 28.6074 165.7C28.6074 165.46 28.8026 165.265 29.0435 165.265C29.2843 165.265 29.4795 165.46 29.4795 165.7Z"
          fill="black"
        />
        <path
          d="M65.417 165.7C65.417 165.94 65.2218 166.135 64.981 166.135C64.7401 166.135 64.5449 165.94 64.5449 165.7C64.5449 165.46 64.7401 165.265 64.981 165.265C65.2218 165.265 65.417 165.46 65.417 165.7Z"
          fill="black"
        />
        <path
          d="M137.292 165.7C137.292 165.94 137.097 166.135 136.856 166.135C136.615 166.135 136.42 165.94 136.42 165.7C136.42 165.46 136.615 165.265 136.856 165.265C137.097 165.265 137.292 165.46 137.292 165.7Z"
          fill="black"
        />
        <path
          d="M41.458 165.7C41.458 165.94 41.2628 166.135 41.022 166.135C40.7812 166.135 40.5859 165.94 40.5859 165.7C40.5859 165.46 40.7812 165.265 41.022 165.265C41.2628 165.265 41.458 165.46 41.458 165.7Z"
          fill="black"
        />
        <path
          d="M77.3955 165.7C77.3955 165.94 77.2003 166.135 76.9595 166.135C76.7187 166.135 76.5234 165.94 76.5234 165.7C76.5234 165.46 76.7187 165.265 76.9595 165.265C77.2003 165.265 77.3955 165.46 77.3955 165.7Z"
          fill="black"
        />
        <path
          d="M149.271 165.7C149.271 165.94 149.075 166.135 148.834 166.135C148.594 166.135 148.398 165.94 148.398 165.7C148.398 165.46 148.594 165.265 148.834 165.265C149.075 165.265 149.271 165.46 149.271 165.7Z"
          fill="black"
        />
        <path
          d="M101.355 165.7C101.355 165.94 101.159 166.135 100.918 166.135C100.678 166.135 100.482 165.94 100.482 165.7C100.482 165.46 100.678 165.265 100.918 165.265C101.159 165.265 101.355 165.46 101.355 165.7Z"
          fill="black"
        />
        <path
          d="M173.228 165.7C173.228 165.94 173.032 166.135 172.792 166.135C172.551 166.135 172.355 165.94 172.355 165.7C172.355 165.46 172.551 165.265 172.792 165.265C173.032 165.265 173.228 165.46 173.228 165.7Z"
          fill="black"
        />
        <path
          d="M53.4385 165.7C53.4385 165.94 53.2433 166.135 53.0025 166.135C52.7616 166.135 52.5664 165.94 52.5664 165.7C52.5664 165.46 52.7616 165.265 53.0025 165.265C53.2433 165.265 53.4385 165.46 53.4385 165.7Z"
          fill="black"
        />
        <path
          d="M125.312 165.7C125.312 165.94 125.116 166.135 124.876 166.135C124.635 166.135 124.439 165.94 124.439 165.7C124.439 165.46 124.635 165.265 124.876 165.265C125.116 165.265 125.312 165.46 125.312 165.7Z"
          fill="black"
        />
        <path
          d="M89.3741 165.7C89.3741 165.94 89.1788 166.135 88.938 166.135C88.6972 166.135 88.502 165.94 88.502 165.7C88.502 165.46 88.6972 165.265 88.938 165.265C89.1788 165.265 89.3741 165.46 89.3741 165.7Z"
          fill="black"
        />
        <path
          d="M161.249 165.7C161.249 165.94 161.054 166.135 160.813 166.135C160.572 166.135 160.377 165.94 160.377 165.7C160.377 165.46 160.572 165.265 160.813 165.265C161.054 165.265 161.249 165.46 161.249 165.7Z"
          fill="black"
        />
        <path
          d="M113.333 165.7C113.333 165.94 113.138 166.135 112.897 166.135C112.656 166.135 112.461 165.94 112.461 165.7C112.461 165.46 112.656 165.265 112.897 165.265C113.138 165.265 113.333 165.46 113.333 165.7Z"
          fill="black"
        />
        <path
          d="M29.4795 82.0378C29.4795 82.2781 29.2843 82.4729 29.0435 82.4729C28.8026 82.4729 28.6074 82.2781 28.6074 82.0378C28.6074 81.7976 28.8026 81.6028 29.0435 81.6028C29.2843 81.6028 29.4795 81.7976 29.4795 82.0378Z"
          fill="black"
        />
        <path
          d="M65.417 82.0378C65.417 82.2781 65.2218 82.4729 64.981 82.4729C64.7401 82.4729 64.5449 82.2781 64.5449 82.0378C64.5449 81.7976 64.7401 81.6028 64.981 81.6028C65.2218 81.6028 65.417 81.7976 65.417 82.0378Z"
          fill="black"
        />
        <path
          d="M137.292 82.0378C137.292 82.2781 137.097 82.4729 136.856 82.4729C136.615 82.4729 136.42 82.2781 136.42 82.0378C136.42 81.7976 136.615 81.6028 136.856 81.6028C137.097 81.6028 137.292 81.7976 137.292 82.0378Z"
          fill="black"
        />
        <path
          d="M41.458 82.0378C41.458 82.2781 41.2628 82.4729 41.022 82.4729C40.7812 82.4729 40.5859 82.2781 40.5859 82.0378C40.5859 81.7976 40.7812 81.6028 41.022 81.6028C41.2628 81.6028 41.458 81.7976 41.458 82.0378Z"
          fill="black"
        />
        <path
          d="M77.3955 82.0378C77.3955 82.2781 77.2003 82.4729 76.9595 82.4729C76.7187 82.4729 76.5234 82.2781 76.5234 82.0378C76.5234 81.7976 76.7187 81.6028 76.9595 81.6028C77.2003 81.6028 77.3955 81.7976 77.3955 82.0378Z"
          fill="black"
        />
        <path
          d="M149.271 82.0378C149.271 82.2781 149.075 82.4729 148.834 82.4729C148.594 82.4729 148.398 82.2781 148.398 82.0378C148.398 81.7976 148.594 81.6028 148.834 81.6028C149.075 81.6028 149.271 81.7976 149.271 82.0378Z"
          fill="black"
        />
        <path
          d="M101.355 82.0378C101.355 82.2781 101.159 82.4729 100.918 82.4729C100.678 82.4729 100.482 82.2781 100.482 82.0378C100.482 81.7976 100.678 81.6028 100.918 81.6028C101.159 81.6028 101.355 81.7976 101.355 82.0378Z"
          fill="black"
        />
        <path
          d="M173.228 82.0378C173.228 82.2781 173.032 82.4729 172.792 82.4729C172.551 82.4729 172.355 82.2781 172.355 82.0378C172.355 81.7976 172.551 81.6028 172.792 81.6028C173.032 81.6028 173.228 81.7976 173.228 82.0378Z"
          fill="black"
        />
        <path
          d="M53.4385 82.0378C53.4385 82.2781 53.2433 82.4729 53.0025 82.4729C52.7616 82.4729 52.5664 82.2781 52.5664 82.0378C52.5664 81.7976 52.7616 81.6028 53.0025 81.6028C53.2433 81.6028 53.4385 81.7976 53.4385 82.0378Z"
          fill="black"
        />
        <path
          d="M125.312 82.0378C125.312 82.2781 125.116 82.4729 124.876 82.4729C124.635 82.4729 124.439 82.2781 124.439 82.0378C124.439 81.7976 124.635 81.6028 124.876 81.6028C125.116 81.6028 125.312 81.7976 125.312 82.0378Z"
          fill="black"
        />
        <path
          d="M89.3741 82.0378C89.3741 82.2781 89.1788 82.4729 88.938 82.4729C88.6972 82.4729 88.502 82.2781 88.502 82.0378C88.502 81.7976 88.6972 81.6028 88.938 81.6028C89.1788 81.6028 89.3741 81.7976 89.3741 82.0378Z"
          fill="black"
        />
        <path
          d="M161.249 82.0378C161.249 82.2781 161.054 82.4729 160.813 82.4729C160.572 82.4729 160.377 82.2781 160.377 82.0378C160.377 81.7976 160.572 81.6028 160.813 81.6028C161.054 81.6028 161.249 81.7976 161.249 82.0378Z"
          fill="black"
        />
        <path
          d="M113.333 82.0378C113.333 82.2781 113.138 82.4729 112.897 82.4729C112.656 82.4729 112.461 82.2781 112.461 82.0378C112.461 81.7976 112.656 81.6028 112.897 81.6028C113.138 81.6028 113.333 81.7976 113.333 82.0378Z"
          fill="black"
        />
        <path
          d="M29.4795 129.845C29.4795 130.085 29.2843 130.28 29.0435 130.28C28.8026 130.28 28.6074 130.085 28.6074 129.845C28.6074 129.605 28.8026 129.41 29.0435 129.41C29.2843 129.41 29.4795 129.605 29.4795 129.845Z"
          fill="black"
        />
        <path
          d="M65.417 129.845C65.417 130.085 65.2218 130.28 64.981 130.28C64.7401 130.28 64.5449 130.085 64.5449 129.845C64.5449 129.605 64.7401 129.41 64.981 129.41C65.2218 129.41 65.417 129.605 65.417 129.845Z"
          fill="black"
        />
        <path
          d="M137.292 129.845C137.292 130.085 137.097 130.28 136.856 130.28C136.615 130.28 136.42 130.085 136.42 129.845C136.42 129.605 136.615 129.41 136.856 129.41C137.097 129.41 137.292 129.605 137.292 129.845Z"
          fill="black"
        />
        <path
          d="M41.458 129.845C41.458 130.085 41.2628 130.28 41.022 130.28C40.7812 130.28 40.5859 130.085 40.5859 129.845C40.5859 129.605 40.7812 129.41 41.022 129.41C41.2628 129.41 41.458 129.605 41.458 129.845Z"
          fill="black"
        />
        <path
          d="M77.3955 129.845C77.3955 130.085 77.2003 130.28 76.9595 130.28C76.7187 130.28 76.5234 130.085 76.5234 129.845C76.5234 129.605 76.7187 129.41 76.9595 129.41C77.2003 129.41 77.3955 129.605 77.3955 129.845Z"
          fill="black"
        />
        <path
          d="M149.271 129.845C149.271 130.085 149.075 130.28 148.834 130.28C148.594 130.28 148.398 130.085 148.398 129.845C148.398 129.605 148.594 129.41 148.834 129.41C149.075 129.41 149.271 129.605 149.271 129.845Z"
          fill="black"
        />
        <path
          d="M101.355 129.845C101.355 130.085 101.159 130.28 100.918 130.28C100.678 130.28 100.482 130.085 100.482 129.845C100.482 129.605 100.678 129.41 100.918 129.41C101.159 129.41 101.355 129.605 101.355 129.845Z"
          fill="black"
        />
        <path
          d="M173.228 129.845C173.228 130.085 173.032 130.28 172.792 130.28C172.551 130.28 172.355 130.085 172.355 129.845C172.355 129.605 172.551 129.41 172.792 129.41C173.032 129.41 173.228 129.605 173.228 129.845Z"
          fill="black"
        />
        <path
          d="M53.4385 129.845C53.4385 130.085 53.2433 130.28 53.0025 130.28C52.7616 130.28 52.5664 130.085 52.5664 129.845C52.5664 129.605 52.7616 129.41 53.0025 129.41C53.2433 129.41 53.4385 129.605 53.4385 129.845Z"
          fill="black"
        />
        <path
          d="M125.312 129.845C125.312 130.085 125.116 130.28 124.876 130.28C124.635 130.28 124.439 130.085 124.439 129.845C124.439 129.605 124.635 129.41 124.876 129.41C125.116 129.41 125.312 129.605 125.312 129.845Z"
          fill="black"
        />
        <path
          d="M89.3741 129.845C89.3741 130.085 89.1788 130.28 88.938 130.28C88.6972 130.28 88.502 130.085 88.502 129.845C88.502 129.605 88.6972 129.41 88.938 129.41C89.1788 129.41 89.3741 129.605 89.3741 129.845Z"
          fill="black"
        />
        <path
          d="M161.249 129.845C161.249 130.085 161.054 130.28 160.813 130.28C160.572 130.28 160.377 130.085 160.377 129.845C160.377 129.605 160.572 129.41 160.813 129.41C161.054 129.41 161.249 129.605 161.249 129.845Z"
          fill="black"
        />
        <path
          d="M113.333 129.845C113.333 130.085 113.138 130.28 112.897 130.28C112.656 130.28 112.461 130.085 112.461 129.845C112.461 129.605 112.656 129.41 112.897 129.41C113.138 129.41 113.333 129.605 113.333 129.845Z"
          fill="black"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M154.911 28.7645C154.369 28.9664 153.766 28.692 153.564 28.1516C149.828 18.1752 137.656 12.1653 127.44 15.2499C127.117 15.3478 126.798 15.4554 126.483 15.5727C128.074 17.0653 129.325 18.9722 129.631 21.2373C129.865 22.9664 129.344 24.7681 128.352 26.1396C127.358 27.5148 125.807 28.5628 123.93 28.554L123.929 28.554C121.789 28.5421 120.158 27.1664 119.253 25.5007C118.351 23.8395 118.06 21.7108 118.724 19.8596C119.428 17.899 120.84 16.3841 122.519 15.2544C114.916 10.9362 104.032 13.429 99.1552 20.6842C99.1008 20.7661 99.0476 20.8483 98.9957 20.9306C100.137 21.3871 101.247 22.134 102.022 23.0288C102.526 23.6105 102.941 24.3157 103.073 25.1036C103.212 25.9271 103.027 26.7672 102.454 27.5129L102.45 27.5173L102.447 27.5217C101.487 28.7423 99.9749 28.8555 98.7949 28.4897C97.6192 28.1251 96.4724 27.2138 96.0227 25.926C95.6007 24.7175 95.6918 23.4895 96.0327 22.3537C92.1867 21.7311 88.2384 22.0491 84.5305 23.2909C80.3421 24.6935 76.6223 27.2205 73.7796 30.5942C73.4076 31.0358 72.7472 31.0928 72.3047 30.7216C71.8621 30.3505 71.805 29.6916 72.177 29.2501C75.2673 25.5824 79.3111 22.8353 83.8643 21.3105C88.0625 19.9046 92.544 19.5879 96.8883 20.3814C97.0573 20.0801 97.2346 19.7941 97.4124 19.5266L97.4138 19.5245L97.4152 19.5225C103.019 11.1824 115.516 8.46462 124.094 13.7584C124.267 13.8647 124.439 13.9752 124.61 14.0898C125.345 13.7527 126.095 13.4745 126.831 13.2513L126.832 13.2509C138.106 9.84647 151.403 16.4111 155.525 27.4206C155.727 27.961 155.452 28.5627 154.911 28.7645ZM98.0807 22.8168C97.8022 23.6739 97.7427 24.5023 97.9998 25.2387C98.1906 25.785 98.7473 26.2874 99.4163 26.4949C100.078 26.7001 100.55 26.5459 100.796 26.2364C101.01 25.957 101.052 25.7055 101.009 25.4495C100.959 25.1563 100.783 24.7923 100.438 24.3948C99.8649 23.7331 98.9734 23.1482 98.0807 22.8168ZM124.411 16.5369C122.683 17.527 121.301 18.875 120.695 20.5639C120.26 21.7772 120.433 23.2883 121.094 24.5053C121.752 25.7175 122.783 26.4584 123.94 26.4651M124.411 16.5369C126.071 17.8838 127.296 19.5933 127.556 21.5167C127.712 22.6682 127.361 23.9396 126.654 24.9177C125.95 25.892 124.978 26.4699 123.94 26.4651"
        fill="#1BEDA7"
      />
      <path
        d="M55.7565 134.525C70.8224 138.987 55.8924 124.445 68.3492 120.727L136.028 126.305C144.071 127.577 161.452 131.002 166.631 134.525C173.104 138.929 144.267 134.525 146.327 137.167C148.387 139.81 136.616 146.856 118.961 148.03C101.306 149.204 98.3633 153.021 88.6529 158.305C78.9424 163.59 20.0914 163.59 9.20392 160.067C-1.68353 156.544 26.2707 153.902 29.2133 149.791C32.1558 145.681 31.9218 145.094 27.2138 142.745C22.5057 140.397 34.8644 132.764 55.7565 134.525Z"
        fill="#18002D"
      />
      <path
        d="M48.7402 64.3766H99.5449V96.4496H48.7402V64.3766Z"
        fill="#848484"
      />
      <path
        d="M48.7402 36.7426H99.5449V128.523H48.7402V36.7426Z"
        fill="url(#paint0_linear_12042_41755)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.3457 35.35H100.942V129.915H47.3457V35.35ZM48.7415 36.7426V128.523H99.5461V36.7426H48.7415Z"
        fill="black"
      />
      <path
        d="M93.5781 36.7426H99.5454V128.523H93.5781V36.7426Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.1816 35.35H100.94V129.915H92.1816V35.35ZM93.5774 36.7426V128.523H99.5447V36.7426H93.5774Z"
        fill="black"
      />
      <path
        d="M100.771 36.7426H144.889V128.523H100.771V36.7426Z"
        fill="url(#paint1_linear_12042_41755)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.377 35.35H146.286V129.915H99.377V35.35ZM100.773 36.7426V128.523H144.89V36.7426H100.773Z"
        fill="black"
      />
      <path
        d="M23.6934 34.4192H74.498V66.4922H23.6934V34.4192Z"
        fill="#5380F2"
      />
      <path
        d="M48.7402 96.4496H99.5449V128.523H48.7402V96.4496Z"
        fill="#5380F2"
      />
      <path
        d="M74.498 38.8582H99.5448V64.0821H74.498V38.8582Z"
        fill="#4A5458"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.1445 112.486C86.1445 112.053 86.496 111.703 86.9297 111.703H91.5286C91.9623 111.703 92.3138 112.053 92.3138 112.486C92.3138 112.919 91.9623 113.269 91.5286 113.269H86.9297C86.496 113.269 86.1445 112.919 86.1445 112.486Z"
        fill="#092A38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.8398 112.486C54.8398 111.429 55.6991 110.571 56.759 110.571H88.8087C89.8686 110.571 90.7279 111.429 90.7279 112.486C90.7279 113.544 89.8686 114.401 88.8087 114.401H56.759C55.6991 114.401 54.8398 113.544 54.8398 112.486Z"
        fill="#092A38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.0977 51.4701C61.0977 51.0375 61.4492 50.6868 61.8828 50.6868H66.4818C66.9154 50.6868 67.2669 51.0375 67.2669 51.4701C67.2669 51.9027 66.9154 52.2534 66.4818 52.2534H61.8828C61.4492 52.2534 61.0977 51.9027 61.0977 51.4701Z"
        fill="#092A38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.793 51.4701C29.793 50.4126 30.6522 49.5553 31.7122 49.5553H63.7618C64.8217 49.5553 65.681 50.4126 65.681 51.4701C65.681 52.5276 64.8217 53.3849 63.7618 53.3849H31.7122C30.6522 53.3849 29.793 52.5276 29.793 51.4701Z"
        fill="#092A38"
      />
      <path
        d="M74.498 34.4192H77.2896V66.4922H74.498V34.4192Z"
        fill="#092A38"
      />
      <path
        d="M68.4711 117.554L121.097 118.078L120.644 141.497L68.0272 140.488L68.4711 117.554Z"
        fill="#373F43"
      />
      <path
        d="M73.5977 130.389L118.094 118.023L121.096 118.08L76.5995 130.446L73.5977 130.389Z"
        fill="#D9D9D9"
      />
      <path
        d="M25.207 129.339L68.807 117.075L71.8088 117.132L28.2088 129.396L25.207 129.339Z"
        fill="#D9D9D9"
      />
      <path
        d="M26.9316 129.794L68.4839 118.036L68.0508 140.41L26.0045 154.849L26.9316 129.794Z"
        fill="#4A5458"
      />
      <path
        d="M25.0703 125.161L75.8641 126.135L75.2435 158.204L24.4496 157.23L25.0703 125.161Z"
        fill="#5380F2"
      />
      <path
        d="M75.7785 130.576L121.096 118.078L120.642 141.533L75.2904 155.796L75.7785 130.576Z"
        fill="#4A5458"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.1352 142.928C62.1436 142.495 62.5018 142.151 62.9354 142.159L67.5334 142.247C67.9669 142.256 68.3116 142.613 68.3032 143.046C68.2948 143.478 67.9365 143.823 67.503 143.814L62.905 143.726C62.4715 143.718 62.1268 143.36 62.1352 142.928Z"
        fill="#092A38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.836 142.327C30.8564 141.269 31.7321 140.428 32.7919 140.448L64.8353 141.063C65.895 141.083 66.7375 141.957 66.717 143.015C66.6965 144.073 65.8208 144.914 64.7611 144.894L32.7177 144.28C31.6579 144.259 30.8155 143.385 30.836 142.327Z"
        fill="#092A38"
      />
      <path
        d="M75.8649 126.137L78.6766 125.061L78.0561 157.128L75.2444 158.204L75.8649 126.137Z"
        fill="#092A38"
      />
      <path
        d="M75.8766 126.138L78.7071 125.076L28.3555 123.882L25.0694 125.162L75.8766 126.138Z"
        fill="#81A0EF"
      />
      <path
        d="M68.1485 118.072L117.12 119.012L120.761 118.072L71.7895 117.132L68.1485 118.072Z"
        fill="#D9D9D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.9774 64.9579C99.0289 65.0392 99.0046 65.1467 98.9231 65.1981L49.3087 96.4819C49.2273 96.5332 49.1195 96.509 49.068 96.4277C49.0165 96.3464 49.0408 96.2389 49.1223 96.1876L98.7367 64.9038C98.8182 64.8524 98.9259 64.8767 98.9774 64.9579Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.1906 64.713C99.2638 64.7755 99.2723 64.8854 99.2097 64.9584L72.518 96.0713C72.4553 96.1443 72.3452 96.1529 72.272 96.0903C72.1988 96.0278 72.1902 95.9179 72.2529 95.8449L98.9446 64.732C99.0072 64.659 99.1174 64.6505 99.1906 64.713Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.9803 64.6781C99.0728 64.705 99.126 64.8016 99.099 64.8939L90.0569 95.8808C90.0299 95.9731 89.9331 96.0262 89.8406 95.9993C89.7481 95.9724 89.6949 95.8758 89.7218 95.7835L98.764 64.7966C98.7909 64.7043 98.8878 64.6513 98.9803 64.6781Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.0889 64.9629C99.1851 64.9692 99.2579 65.0521 99.2516 65.148L97.2412 95.592C97.2348 95.6879 97.1517 95.7605 97.0556 95.7542C96.9594 95.7479 96.8866 95.665 96.893 95.5691L98.9034 65.1252C98.9097 65.0292 98.9928 64.9566 99.0889 64.9629Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.5524 90.9949C58.2607 91.0903 57.9792 91.1823 57.7077 91.2681C57.6158 91.2972 57.5178 91.2464 57.4887 91.1547C57.4596 91.0631 57.5104 90.9653 57.6023 90.9362C57.8698 90.8517 58.1486 90.7605 58.4386 90.6656C60.1967 90.0907 62.3701 89.3798 64.9834 89.1812C68.0202 88.9504 71.6478 89.4102 75.9326 91.5531C76.2764 91.4674 76.6463 91.3656 77.0395 91.2574C80.4368 90.3226 85.5704 88.91 90.6017 93.2378C91.3873 93.0069 92.6055 92.7724 93.8327 92.785C95.103 92.7981 96.4245 93.0766 97.2664 93.9466C97.3333 94.0158 97.3314 94.126 97.2621 94.1928C97.1928 94.2595 97.0823 94.2576 97.0154 94.1884C96.2722 93.4205 95.0698 93.1459 93.8291 93.1331C92.595 93.1204 91.3642 93.3673 90.6112 93.5985L90.5183 93.627L90.4451 93.5632C85.5401 89.2888 80.5601 90.6541 77.1414 91.5914C76.7209 91.7067 76.3239 91.8155 75.9537 91.9066L75.891 91.922L75.8334 91.893C71.581 89.7542 67.9979 89.3013 65.0099 89.5284C62.442 89.7235 60.311 90.4201 58.5524 90.9949Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.3717 84.6734C68.1385 84.7453 67.9125 84.8149 67.693 84.8801C67.6007 84.9075 67.5035 84.855 67.476 84.7629C67.4486 84.6707 67.5012 84.5738 67.5935 84.5464C67.8085 84.4826 68.0315 84.4138 68.2628 84.3425C69.5913 83.9328 71.1937 83.4386 73.129 83.3099C75.3943 83.1591 78.1119 83.5079 81.4049 85.0534C81.6654 84.9922 81.9457 84.9197 82.2435 84.8427C84.8514 84.1682 88.8084 83.1448 92.6871 86.2687C93.2951 86.1056 94.1873 85.9848 95.0849 86.0402C96.0228 86.0981 96.9994 86.3505 97.6528 86.9847C97.7218 87.0517 97.7233 87.1619 97.6561 87.2308C97.5889 87.2998 97.4785 87.3013 97.4094 87.2342C96.8441 86.6855 95.9681 86.4435 95.0633 86.3877C94.1628 86.3321 93.2665 86.4631 92.6955 86.6278L92.6073 86.6532L92.5364 86.5951C88.7804 83.5205 84.9686 84.5017 82.3395 85.1784C82.0159 85.2617 81.7102 85.3404 81.4248 85.4063L81.3656 85.42L81.3107 85.394C78.0457 83.8514 75.3698 83.5097 73.1522 83.6572C71.261 83.7831 69.7004 84.264 68.3717 84.6734Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.5287 78.892C77.3039 78.9721 77.0856 79.0499 76.8723 79.1209C76.7809 79.1513 76.6821 79.102 76.6516 79.0108C76.6211 78.9196 76.6705 78.821 76.7619 78.7906C76.9645 78.7232 77.1753 78.648 77.3953 78.5695C78.3097 78.2434 79.381 77.8614 80.6667 77.7487C82.2577 77.6093 84.1734 77.8799 86.5662 79.1351C86.7479 79.0868 86.943 79.0302 87.1503 78.97C89.0415 78.4212 91.9414 77.5797 94.7785 80.1226C95.2097 79.9925 95.775 79.8827 96.3486 79.9129C96.9676 79.9454 97.6105 80.1423 98.094 80.6685C98.1591 80.7394 98.1543 80.8495 98.0833 80.9145C98.0123 80.9794 97.9019 80.9746 97.8368 80.9038C97.434 80.4654 96.8904 80.29 96.3302 80.2605C95.7687 80.231 95.2049 80.3497 94.7889 80.4842L94.692 80.5155L94.617 80.4467C91.909 77.9613 89.1696 78.7511 87.2573 79.3025C87.0213 79.3706 86.7979 79.435 86.5887 79.4892L86.523 79.5062L86.4631 79.4744C84.0965 78.2208 82.2289 77.9613 80.6972 78.0955C79.4607 78.2039 78.4407 78.5672 77.5287 78.892Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.6576 74.303C84.5057 74.358 84.3573 74.4118 84.2109 74.4612C84.1196 74.492 84.0206 74.4432 83.9897 74.3521C83.9588 74.261 84.0078 74.1622 84.0991 74.1314C84.2339 74.0859 84.3744 74.0349 84.5211 73.9817C85.1213 73.7639 85.825 73.5085 86.6691 73.4356C87.716 73.3452 88.9746 73.5327 90.5604 74.3724C90.673 74.3417 90.7938 74.3061 90.9219 74.2683C92.1704 73.9002 94.1164 73.3265 96.017 75.0341C96.3172 74.9463 96.7503 74.8636 97.1883 74.8684C97.6714 74.8737 98.2008 74.9865 98.5437 75.365C98.6083 75.4363 98.6027 75.5464 98.5313 75.6109C98.4598 75.6754 98.3494 75.6698 98.2848 75.5985C98.0398 75.328 97.6329 75.2215 97.1845 75.2166C96.7416 75.2117 96.2975 75.3067 96.0274 75.3953L95.9294 75.4275L95.8539 75.3572C94.0833 73.709 92.2997 74.2298 91.0304 74.6004C90.8732 74.6463 90.7238 74.6899 90.5834 74.7268L90.5169 74.7442L90.4563 74.7117C88.8946 73.8726 87.6845 73.6973 86.6992 73.7824C85.9056 73.851 85.2549 74.0867 84.6576 74.303Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.2266 100.976V66.8975H55.5755V100.976H55.2266Z"
        fill="white"
      />
      <path
        d="M59.0081 104.879C59.0081 107.126 57.3995 108.947 55.4152 108.947C53.4309 108.947 51.8223 107.126 51.8223 104.879C51.8223 102.632 53.4309 100.811 55.4152 100.811C57.3995 100.811 59.0081 102.632 59.0081 104.879Z"
        fill="#F9A56B"
      />
      <path
        d="M57.835 108.512C57.835 110.026 56.7509 111.253 55.4136 111.253C54.0763 111.253 52.9922 110.026 52.9922 108.512C52.9922 106.998 54.0763 105.77 55.4136 105.77C56.7509 105.77 57.835 106.998 57.835 108.512Z"
        fill="#F9A56B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.2534 114.356C47.472 114.457 47.7313 114.362 47.8325 114.144L50.2707 108.891L53.2105 109.393L53.3577 108.535L49.7597 107.92L47.0409 113.778C46.9397 113.996 47.0348 114.255 47.2534 114.356Z"
        fill="#F9A56B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.4019 110.428C46.5856 110.584 46.8608 110.561 47.0167 110.378L50.7723 105.965L53.471 107.232L53.8424 106.444L50.5395 104.894L46.3517 109.815C46.1958 109.998 46.2183 110.272 46.4019 110.428Z"
        fill="#F9A56B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.8282 106.615C45.9639 106.814 46.2352 106.865 46.4343 106.73L51.2294 103.47L53.4941 105.407L54.0618 104.746L51.29 102.376L45.9431 106.011C45.744 106.146 45.6926 106.417 45.8282 106.615Z"
        fill="#F9A56B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.3247 103.842C46.4603 104.041 46.7316 104.092 46.9307 103.957L51.4211 100.906L53.9931 104.57L54.7076 104.071L51.6417 99.7035L46.4398 103.237C46.2406 103.373 46.1891 103.643 46.3247 103.842Z"
        fill="#F9A56B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.5454 114.356C63.3268 114.457 63.0675 114.362 62.9663 114.144L60.5281 108.891L57.5883 109.393L57.4411 108.535L61.0391 107.92L63.7579 113.778C63.8592 113.996 63.764 114.255 63.5454 114.356Z"
        fill="#F9A56B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.3969 110.428C64.2133 110.584 63.938 110.561 63.7821 110.378L60.0265 105.965L57.3278 107.232L56.9564 106.444L60.2593 104.894L64.4471 109.815C64.603 109.998 64.5805 110.272 64.3969 110.428Z"
        fill="#F9A56B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.9706 106.615C64.8349 106.814 64.5636 106.865 64.3645 106.73L59.5694 103.47L57.3047 105.407L56.7371 104.746L59.5088 102.376L64.8558 106.011C65.0548 106.146 65.1062 106.417 64.9706 106.615Z"
        fill="#F9A56B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.4741 103.842C64.3386 104.041 64.0672 104.092 63.8681 103.957L59.3778 100.906L56.8058 104.57L56.0912 104.071L59.1571 99.7035L64.3591 103.237C64.5582 103.373 64.6097 103.643 64.4741 103.842Z"
        fill="#F9A56B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M169.554 96.9041C169.064 97.2112 168.418 97.0642 168.11 96.5759C167.738 95.9852 167.251 95.4751 166.677 95.0757C166.104 94.6764 165.456 94.3958 164.772 94.2508C164.088 94.1058 163.382 94.0992 162.696 94.2314C162.224 94.3223 161.768 94.4775 161.34 94.6919C161.6 94.9656 161.824 95.2735 162.006 95.6087L162.013 95.622L162.02 95.6356C162.264 96.1196 162.342 96.6702 162.242 97.2029C162.143 97.7356 161.87 98.2208 161.467 98.5842L161.397 98.6475L161.317 98.6972C160.812 99.0091 160.208 99.1196 159.625 99.0066C159.042 98.8937 158.524 98.5655 158.173 98.0879L158.159 98.0689L158.146 98.0493C157.862 97.625 157.693 97.1351 157.655 96.6268C157.617 96.1184 157.71 95.6087 157.927 95.1469L157.932 95.1354L157.938 95.1241C157.951 95.0974 157.964 95.0709 157.978 95.0445C156.425 94.4117 154.705 94.2609 153.046 94.6308C152.482 94.7566 151.923 94.4023 151.796 93.8393C151.67 93.2764 152.025 92.718 152.59 92.5922C154.904 92.0759 157.316 92.3693 159.427 93.4052C159.492 93.3599 159.559 93.3162 159.627 93.2742C160.436 92.7362 161.344 92.3643 162.299 92.1804C163.26 91.9952 164.249 92.0044 165.207 92.2076C166.165 92.4107 167.073 92.8036 167.876 93.363C168.679 93.9223 169.361 94.6367 169.883 95.464C170.19 95.9523 170.043 96.5971 169.554 96.9041ZM159.794 96.1013C159.751 96.2188 159.733 96.3444 159.743 96.4698C159.753 96.611 159.798 96.7474 159.873 96.8676C159.912 96.9133 159.965 96.9446 160.024 96.9561C160.06 96.963 160.096 96.9625 160.131 96.955C160.157 96.9138 160.175 96.8678 160.184 96.8192C160.199 96.74 160.189 96.6582 160.155 96.5853C160.057 96.4076 159.935 96.2449 159.794 96.1013Z"
        fill="#ED5B1B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.2272 80.2071C24.4275 80.7483 24.1501 81.3489 23.6078 81.5487C22.9518 81.7903 22.3511 82.1609 21.8412 82.6384C21.3313 83.1159 20.9227 83.6905 20.6395 84.3284C20.3563 84.9662 20.2043 85.6542 20.1925 86.3517C20.1843 86.8311 20.2426 87.3082 20.3647 87.7698C20.6867 87.5726 21.0349 87.4172 21.401 87.3091L21.4156 87.3048L21.4303 87.3009C21.9554 87.1623 22.5115 87.1994 23.0134 87.4065C23.5152 87.6137 23.935 87.9795 24.2083 88.4478L24.256 88.5295L24.2882 88.6183C24.49 89.1753 24.4739 89.7879 24.243 90.3336C24.012 90.8793 23.5833 91.318 23.0425 91.5622L23.021 91.5719L22.9992 91.5806C22.5246 91.7697 22.0093 91.8337 21.5028 91.7664C20.9963 91.6991 20.5157 91.5028 20.1074 91.1964L20.0972 91.1888L20.0873 91.1809C20.0639 91.1624 20.0406 91.1437 20.0176 91.1248C19.0769 92.5107 18.5743 94.1594 18.5953 95.8544C18.6024 96.4312 18.1396 96.9046 17.5615 96.9117C16.9834 96.9188 16.5089 96.457 16.5018 95.8802C16.4725 93.5139 17.2573 91.2199 18.7084 89.3729C18.6774 89.2997 18.6483 89.2255 18.6211 89.1505C18.2602 88.2498 18.0827 87.2864 18.0991 86.3164C18.1156 85.3395 18.3285 84.3757 18.7252 83.4823C19.1219 82.5889 19.6943 81.784 20.4084 81.1153C21.1225 80.4466 21.9638 79.9276 22.8826 79.5891C23.425 79.3893 24.027 79.666 24.2272 80.2071ZM21.4283 89.5698C21.5347 89.6361 21.6543 89.6792 21.7792 89.6958C21.9199 89.7145 22.0629 89.699 22.1961 89.6508C22.2489 89.6223 22.2907 89.5766 22.3142 89.5211C22.3282 89.4879 22.3352 89.4525 22.335 89.417C22.3 89.383 22.2586 89.3556 22.2129 89.3367C22.1383 89.3059 22.0559 89.2992 21.9774 89.3174C21.7828 89.3767 21.5982 89.4618 21.4283 89.5698Z"
        fill="#CFA1FF"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12042_41755"
          x1="61.1814"
          y1="75.3962"
          x2="101.783"
          y2="78.1091"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#778496" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12042_41755"
          x1="107.536"
          y1="71.3452"
          x2="164.521"
          y2="51.8547"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A3D51" />
          <stop offset="1" />
        </linearGradient>
        <clipPath id="clip0_12042_41755">
          <rect
            width="177.073"
            height="181.817"
            fill="white"
            transform="translate(6.46289)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
